import { Link } from "react-router-dom";

function ElectionInformationPage() {
  return (
    <main className="bg-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Page Title */}
        <h1 
          className="text-5xl font-bold text-center mb-16 text-black" 
          style={{ fontFamily: 'Poppins, sans-serif' }}
        >
          Election Information
        </h1>

        {/* Voting Information Section - Big rows with larger text */}
        <div className="space-y-10 mb-16">
          {/* Early Voting - Full width row */}
          <div className="bg-white rounded-lg shadow-lg p-8 border-2 border-indigo-900">
            <h3 className="text-3xl font-bold text-indigo-900 mb-6">Early Voting</h3>
            <p className="text-2xl text-gray-800 mb-4">April 22-25, 28 & 29</p>
            <p className="text-2xl text-gray-800">8 AM - 7 PM</p>
          </div>
          
          {/* Election Day - Full width row */}
          <div className="bg-white rounded-lg shadow-lg p-8 border-2 border-indigo-900">
            <h3 className="text-3xl font-bold text-indigo-900 mb-6">Election Day</h3>
            <p className="text-2xl text-gray-800">May 3</p>
          </div>
        </div>

        {/* Donation Button - Larger */}
        <div className="text-center mb-16">
          <div className="mt-12">
            <Link
              to="/donate"
              className="bg-black hover:bg-indigo-800 text-white text-2xl font-bold py-4 px-10 rounded-full shadow-lg transition"
            >
              DONATE
            </Link>
          </div>
        </div>
      </div>
    </main>
  );
}

export default ElectionInformationPage;